module.exports = __webpack_public_path__ + "static/products-c2c2946258387954de891349bf0c2780.webp";